export default {
  sidebar: {
    switchSide: 'Přepnout strany',
    showSidebar: 'Zobrazit boční panel',
    hideSidebar: 'Skrýt boční panel'
  }
}
